import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.catalog}Recognize/SerialNumber`;

interface SetRecognizeSerialNumberCommandProps {
  imageBase64: string;
}

export const recognizeSerialNumberCommand = async ({
  imageBase64,
}: SetRecognizeSerialNumberCommandProps): Promise<
  BackResponse<string> | BackResponseFailure
> => {
  try {
    const response = await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        imageBase64,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
